export const listOfAuthorsWithProfiles = [
  'aja-mcclanahan',
  'allison-martin',
  'allie-white',
  'anna-baluch',
  'annalise-mantz',
  'ben-luthi',
  'beth-braverman',
  'bev-oshea',
  'bob-sullivan',
  'brian-budzynski',
  'brian-oconnell',
  'brian-oconnor',
  'brian-stack',
  'brianna-mcgurran',
  'carla-fried',
  'casey-morris',
  'chonce-maddox',
  'chris-horymski',
  'daniel-sayre',
  'dom-difurio',
  'ellen-sirull',
  'emily-cahill',
  'emily-starbuck-gerson',
  'eric-rosen',
  'erica-sandberg',
  'eva-velasquez',
  'evelyn-waugh',
  'experian-team',
  'gayle-sato',
  'geoff-williams',
  'hillary-back',
  'ismat-mangla',
  'james-garvey',
  'jamie-johnson',
  'jason-steele',
  'jennifer-brozic',
  'jennifer-white',
  'jim-akin',
  'john-egan',
  'john-ulzheimer',
  'karen-axelton',
  'kat-tretina',
  'kathryn-pomroy',
  'kim-porter',
  'krystian-sip',
  'latoya-irby',
  'lauren-liebhaber',
  'lisa-scherzer',
  'louis-denicola',
  'maria-jaramillo',
  'maria-valdez-haubrich',
  'marianne-hayes',
  'matt-tatham',
  'mel-jones',
  'michael-bruemmer',
  'michelle-black',
  'michelle-jackson',
  'miranda-marquit',
  'reyna-gobel',
  'rod-griffin',
  'sarah-archambault',
  'sarah-brady',
  'stacy-smith',
  'stefan-lembo-stolba',
  'sue-poremba',
  'susan-shain',
  'taylor-medine',
  'taylor-miliam-samuel',
  'tim-maxwell',
  'chelsea-beck',
  'emily-batdorf',
  'aly-yale'
];
export function returnAuthorInitials(fullName: string): string {
  const nameParts = fullName.trim().split(/\s+/);

  if (nameParts.length === 0) {
    return '';
  }

  const firstInitial = nameParts[0].charAt(0).toUpperCase();
  const lastInitial = nameParts[nameParts.length - 1].charAt(0).toUpperCase();

  return `${firstInitial}${lastInitial}`;
}
export function ifAuthorHasProfileImage(slug: string): boolean {
  return listOfAuthorsWithProfiles.includes(slug);
}
export const restrictedAuthors = ['resources-display', 'no-display'];
